module.exports = __webpack_public_path__ + "static/media/overpass-extrabold.5174bc0e.ttf";